module.exports = __webpack_public_path__ + "static/media/noti.1367e59d.png";